import { combineEpics } from "redux-observable";
import { push } from "react-router-redux";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import * as linkedinPixel from "core/integrations/linkedin-pixel";
import * as intercom from "core/integrations/intercom";
import qs from "query-string";
import { candidate, insider } from "routes/paths";
import * as api from "./api";
import * as actions from "./actions";
import * as mixpanel from "core/integrations/mixpanel";

export default combineEpics(
  (action$, store) =>
    action$
      .ofType(api.submitPayment.types.success)
      .do(() => {
        mixpanel.trackEvent("addPaymentInfo");
        dataLayer.push({
          event: "addPaymentInfo"
        });
        fbPixel.fbq("track", "AddPaymentInfo");
        linkedinPixel.track(292585);
      })
      .filter(({ payload }) => payload.request.type === "first")
      .map(({ payload }) =>
        api.checkout.request({
          bookingId: qs.parse(store.getState().router.location.search)
            .bookingId,
          promo_code: qs.parse(store.getState().router.location.search).coupon
        })
      ),
  action$ =>
    action$
      .ofType(api.submitPayment.types.success)
      .mapTo(actions.hideCreateForm()),
  action$ =>
    action$
      .ofType(api.checkout.types.success)
      .do(() => {
        dataLayer.push({
          event: "purchaseComplete"
        });
        mixpanel.increment("Purchases");
        mixpanel.trackEvent("Transaction successful");
        fbPixel.fbq("track", "Purchase");
        intercom.track("purchaseComplete");
        linkedinPixel.track(292593);
      })
      .mapTo(push(candidate.paymentSuccess)),
  action$ =>
    action$
      .ofType(api.createInsiderPaymentInfo.types.success)
      .mapTo(push(insider.insiderDashboardProfile)),
  action$ =>
    action$
      .ofType(api.billingInfo.types.success)
      .map(() => api.billingAccountBalance.request())
);



// WEBPACK FOOTER //
// ./src/modules/payment/epic.js